import type { RouteObject } from "react-router-dom";
import { useMatch, useParams } from "react-router-dom";
import { AdminsPage, type AdminsDrawer } from "./pages/AdminsPage";
import { useLocale } from "@admin/app/locale";

/**
 * One element for all three routes, so moving between the list, `admins/new`
 * and `admins/:id` keeps the same page mounted and only the drawer opens or
 * closes over it.
 */
function AdminsRoute() {
  const locale = useLocale();
  const { id } = useParams();
  const isNew = useMatch("/:locale/admin/admins/new") !== null;
  const drawer: AdminsDrawer = isNew
    ? { mode: "create" }
    : id
      ? { mode: "edit", adminId: id }
      : { mode: "list" };
  return <AdminsPage locale={locale} drawer={drawer} />;
}

export const adminRoutes: RouteObject[] = [
  {
    path: "admins",
    element: <AdminsRoute />,
  },
  {
    path: "admins/new",
    element: <AdminsRoute />,
  },
  {
    path: "admins/:id",
    element: <AdminsRoute />,
  },
];
